import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'i18n-react';
import { Row, Col, Button } from 'react-bootstrap';
import { bootstrapUtils } from 'react-bootstrap/lib/utils';
import './PointsBalance.css';

bootstrapUtils.addStyle(Button, 'alter-search');

const propTypes = {
  name: PropTypes.string.isRequired,
  totalPoints: PropTypes.number.isRequired,
  differenceTotalPoints: PropTypes.number.isRequired,
  callbackAlterSearch: PropTypes.func
};

class PointsBalance extends React.Component {
  constructor() {
    super();

    this.state = {
      isRedirect: false
    };
  }

  getPointsFormatted(value) {
    const pattern = /\B(?=(\d{3})+(?!\d))/g;
    return value.toString().replace(pattern, '.');
  }

  renderMobile() {
    return (
      <div id="pointsBalanceMobile">
        <Row>
          <Col xs={12} lgHidden smHidden mdHidden className="PointsBalance__insufficientPoints">
            {I18n.translate('components.pointsBalance.insufficientPoints', {
              name: this.props.name
            })}
            &nbsp;
            {I18n.translate('components.pointsBalance.buyTicket')}
          </Col>
        </Row>
        <Row>
          <Col xs={12} lgHidden smHidden mdHidden className="PointsBalance__actualAndMissing">
            {I18n.translate('components.pointsBalance.actualAndMissingPoints', {
              totalPoints: this.getPointsFormatted(this.props.totalPoints),
              differenceTotalPoints: this.getPointsFormatted(this.props.differenceTotalPoints)
            })}
          </Col>
        </Row>
        <Row>
          <Col xs={12} lgHidden smHidden mdHidden className="PointsBalance__buttonGridPadding">
            <Button
              id="btnPointsAlterSearchMobile"
              bsStyle="alter-search"
              onClick={this.props.callbackAlterSearch}>
              {I18n.translate('components.pointsBalance.alterSearch')}
            </Button>
          </Col>
          <Col
            xs={12}
            lgHidden
            smHidden
            mdHidden
            className="PointsBalance__buyPointsContainer PointsBalance__buttonGridPadding">
            <a
              id="btnBuyPointsMobile"
              className="btn btn-alter-search"
              href="https://www.voeazul.com.br/br/pt/programa-fidelidade/comprar-pontos"
              target="_blank"
              rel="noopener noreferrer">
              {I18n.translate('components.pointsBalance.buyPoints')}
            </a>
          </Col>
        </Row>
      </div>
    );
  }

  renderDesktop() {
    return (
      <div id="pointsBalanceDesktop">
        <Row>
          <Col xs={12} className="PointsBalance__insufficientPoints" xsHidden>
            {I18n.translate('components.pointsBalance.insufficientPoints', {
              name: this.props.name
            })}{' '}
            <br />
            {I18n.translate('components.pointsBalance.buyTicket')}
          </Col>
        </Row>
        <Row>
          <Col xs={12} className="PointsBalance__actualAndMissing" xsHidden>
            {I18n.translate('components.pointsBalance.actualAndMissingPoints', {
              totalPoints: this.getPointsFormatted(this.props.totalPoints),
              differenceTotalPoints: this.getPointsFormatted(this.props.differenceTotalPoints)
            })}
          </Col>
        </Row>
        <Row>
          <Col xs={6} xsHidden>
            <Button
              id="btnPointsAlterSearchDesk"
              bsStyle="alter-search"
              onClick={this.props.callbackAlterSearch}
              ref={c => {
                this.alterSearch = c;
              }}>
              {I18n.translate('components.pointsBalance.alterSearch')}
            </Button>
          </Col>
          <Col xs={6} className="PointsBalance__buyPointsContainer" xsHidden>
            <a
              id="btnBuyPointsDesk"
              className="btn btn-alter-search btn-buy-points"
              href="https://www.voeazul.com.br/br/pt/programa-fidelidade/comprar-pontos"
              target="_blank"
              rel="noopener noreferrer">
              {I18n.translate('components.pointsBalance.buyPoints')}
            </a>
          </Col>
        </Row>
      </div>
    );
  }

  render() {
    let pointsBalance = <div />;

    if (this.props.name && this.props.differenceTotalPoints > 0) {
      pointsBalance = (
        <div>
          <hr />
          <div id="points-balance" className="PointsBalance">
            {this.renderDesktop()}
            {this.renderMobile()}
          </div>
          <hr />
        </div>
      );
    }
    return pointsBalance;
  }
}

PointsBalance.propTypes = propTypes;

export default PointsBalance;



// WEBPACK FOOTER //
// ./src/components/pointsBalance/PointsBalance.jsx